import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function AdminProjectListPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin/projects`, { credentials: 'include' });
      const data = await response.json();
      setProjects(data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-serif text-white mb-2">Projects</h1>
          <p className="text-gray-400">Manage client projects and trips</p>
        </div>

        <div className="bg-[#0F1629] border border-[#1E293B] rounded-lg overflow-hidden">
          {loading ? (
            <div className="p-8 text-center text-gray-400">Loading...</div>
          ) : projects.length === 0 ? (
            <div className="p-8 text-center text-gray-400">
              <p className="mb-4">No projects yet</p>
              <Link to="/admin/costing" className="text-[#C4A962] hover:underline">
                Create a costing first, then convert it to a project
              </Link>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#0A0F1E] border-b border-[#1E293B]">
                  <tr>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Reference</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Client</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Destination</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Travel Date</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Status</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Est. IDR Cost</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Quotation</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((project) => (
                    <tr key={project.id} className="border-b border-[#1E293B] hover:bg-[#0A0F1E] transition-colors">
                      <td className="p-4 text-sm text-white font-medium">{project.reference}</td>
                      <td className="p-4 text-sm text-gray-300">{project.client_name}</td>
                      <td className="p-4 text-sm text-gray-300">{project.destination}</td>
                      <td className="p-4 text-sm text-gray-300">{project.travel_start_date}</td>
                      <td className="p-4">
                        <span className={`text-xs px-2 py-1 rounded ${
                          project.status === 'Confirmed' ? 'bg-green-500/10 text-green-400' :
                          project.status === 'Quotation' ? 'bg-blue-500/10 text-blue-400' :
                          project.status === 'Inquiry' ? 'bg-yellow-500/10 text-yellow-400' :
                          'bg-gray-500/10 text-gray-400'
                        }`}>
                          {project.status}
                        </span>
                      </td>
                      <td className="p-4 text-sm text-gray-300">
                        IDR {project.estimated_idr_cost?.toLocaleString()}
                      </td>
                      <td className="p-4 text-sm text-gray-300">
                        {project.quotation_currency} {project.quotation_amount?.toLocaleString()}
                      </td>
                      <td className="p-4">
                        <Link
                          to={`/admin/projects/${project.id}`}
                          className="text-[#C4A962] hover:text-[#B89952] text-sm transition-colors"
                        >
                          View →
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
